import { Country } from './country.model';
import { Province } from './province.model';
import { State } from './state.model';

export class Lookups {
  constructor() {
    this.states = new Array();
    this.countries = new Array();
    this.provinces = new Array();
    this.companyStates = new Array();
    this.companyProvinces = new Array();
    this.companyCountries = new Array();
  }

  states: State[];
  countries: Country[];
  provinces: Province[];
  companyStates: any[];
  companyProvinces: any[];
  companyCountries: any[];
}
